import { gql } from '@apollo/client'

export const GET_DISPLAY_AUDIT = gql`
  query GetDisplayAudit($displayAuditId: ID!) {
    displayAudit(displayAuditId: $displayAuditId) {
      __typename
      id
      images {
        id
        url
        boundingBoxSet {
          id
          boundingBoxes {
            id
            label
            confidence
            coordinates {
              minX
              maxX
              minY
              maxY
            }
          }
        }
      }
    }
  }
`
